import { Component } from '@angular/core';

@Component({
    selector: 'app-button-loader',
    templateUrl: './button-loader.component.html',
    styleUrls: ['./button-loader.component.scss'],
    standalone: false
})
export class ButtonLoaderComponent {
}
